import React, { useState } from 'react';
import PropTypes from 'prop-types';
import * as R from 'ramda';
import Drawer from '@mui/material/Drawer';
import Locations from './Locations';
import Summary from './Summary';

const initialState = {
  locations: [],
};

const AddLocationsToDriverWizard = ({ onClose, openDrawer }) => {
  const [step, setStep] = useState(1);
  const [locationState, setLocationState] = useState(initialState);
  const next = () => setStep(R.inc);
  const prev = () => setStep(R.dec);

  const reset = () => {
    setLocationState(initialState);
    prev();
  };

  return (
    <Drawer anchor="right" onClose={onClose} open={openDrawer}>
      {step === 1 && (
        <Locations
          locationState={locationState}
          next={next}
          onClose={onClose}
          prev={prev}
          setLocationState={setLocationState}
        />
      )}
      {step === 2 && (
        <Summary locationState={locationState} onClose={onClose} prev={prev} reset={reset} />
      )}
    </Drawer>
  );
};

AddLocationsToDriverWizard.propTypes = {
  onClose: PropTypes.func.isRequired,
  openDrawer: PropTypes.bool,
};
AddLocationsToDriverWizard.defaultProps = {
  openDrawer: false,
};

export default AddLocationsToDriverWizard;
